import React from 'react'
import { useCookies } from 'react-cookie';
import Modal from 'react-modal'
import { GetCookiesToConsent } from './CookiesToConsent';
import { ConsentAllCookies, ConsentOptionalCookies } from './CookieConsent.action';
import GdprAccordion from './GdprAccordion';
import { CONSENT_COOKIE_KEY } from '../../rutab-constants';
import { translate } from '../../Services/translation';

export const CookieModal = (props) => {
    const [cookies, setCookie] = useCookies([CONSENT_COOKIE_KEY]);
    const cookiesToConsent = GetCookiesToConsent(cookies);
    Modal.setAppElement('#gdpr-cookie-consent-modal');

    const onOptionalClick = () => {
        let optionalCookies = cookiesToConsent.filter(x => x.optional);
        ConsentOptionalCookies(setCookie, optionalCookies);
        props.onRequestClose();
    }

    const onAcceptAllClick = () => {
        ConsentAllCookies(setCookie);
        props.onRequestClose();
    }

    const onToggledConsent = (accepted, key) => {
        let cookieToConsent = cookiesToConsent.find(x => x.key == key);
        if (cookieToConsent === null || cookieToConsent === undefined) {
            return;
        }

        cookieToConsent.accepted = accepted;
    }

    return (
        <Modal
            isOpen={true}
            onRequestClose={props.onRequestClose}
            shouldCloseOnOverlayClick={true}
            className="modal"
        >
            <div className='modal-custom-content'>
                <div className='flex-with-space-between mb-2'>
                    <h4>{translate('cookie.title')}</h4>
                    <h4 className='close-modal-button' onClick={props.onRequestClose}>x</h4>
                </div>
                <div>
                    <p>
                        {translate('cookie.modal.intro.info')}
                    </p>
                    <p>
                        <a href="/policy" className="simple-link-underline">{translate('cookie.policy.link.text')}</a>
                    </p>
                </div>
                <div className="gdpr-accordion">
                    {cookiesToConsent.map(({ key, title, content, trackingServices, optional, accepted }) => (
                        <GdprAccordion
                            key={key}
                            title={title}
                            content={content}
                            accepted={accepted}
                            optional={optional}
                            trackingServices={trackingServices}
                            onToggledThing={(accepted) => onToggledConsent(accepted, key)} />
                    ))}
                </div>
                <div className='flex-with-space-between gap-1'>
                    <button className='button link align-self-center' onClick={onOptionalClick} >{translate('cookie.selection.only.button.text')}</button>
                    <button className='banner-text__button' onClick={onAcceptAllClick}>{translate('cookie.accept.all')}</button>
                </div>
            </div>
        </Modal>
    )
}